import React, { useReducer } from 'react';
import { SurveyFrequency, SurveyDay } from '@Models/SurveyFrequency';
import { SurveyFrequencySettings } from '@Models/SurveyFrequencySettings';
import { SurveyScheduler } from '@Models/SurveyScheduler';

type State = {
    frequencySettings: SurveyFrequencySettings
};

export type SurveyFrequencySettingsAction = {
    type: string;
    surveyFrequency?: SurveyFrequency,
    surveyDay?: SurveyDay,
    openLength?: number,
    latestSurveyDate: Date | null
}

export enum SurveyFrequencySettingsActionType {
    SurveyOptionChanged = "SURVEY_OPTION_CHANGED",
}

const emptyState: State = {
    frequencySettings: new SurveyFrequencySettings('INVALID', 'weekly', 'Monday', new Date(), 1, null)
}

type ContextType = State & {
    dispatch: React.Dispatch<SurveyFrequencySettingsAction>
};

export const SurveyFrequencySettingsContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: SurveyFrequencySettingsAction): State {
    switch (action.type) {
        case SurveyFrequencySettingsActionType.SurveyOptionChanged: {

            const scheduler = new SurveyScheduler(action.latestSurveyDate, 
                action.surveyFrequency || state.frequencySettings.frequency,
                action.surveyDay || state.frequencySettings.day);
        
            const newNextDate = scheduler.nextSurveyDate();

            const newModel  = new SurveyFrequencySettings(
                state.frequencySettings.templateId,
                action.surveyFrequency || state.frequencySettings.frequency,
                action.surveyDay || state.frequencySettings.day,
                newNextDate,
                action.openLength || state.frequencySettings.openLength,
                state.frequencySettings.currentlyOpenUntil
            );
        
            return {
                ...state,
                frequencySettings: newModel
            };
        }
        default:
            return state;
    }
}

export function SurveyFrequencySettingsContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);
    const value = { ...state, dispatch };
    return <SurveyFrequencySettingsContext.Provider value={value}>{props.children}</SurveyFrequencySettingsContext.Provider>;
}
